module.exports = __webpack_public_path__ + "img/arrow-down-language.a995c5b2.svg";